/**
 * useAuth Hook - Agent Authentication
 *
 * FIX: Added loading state so ProtectedRoute waits for localStorage
 * to be read before deciding to redirect. Without this, agent=null
 * for a split second on mount causes instant redirect back to /login.
 */

import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true); // FIX: start as true

  useEffect(() => {
    const stored = localStorage.getItem('janimony_agent');
    if (stored) {
      try {
        setAgent(JSON.parse(stored));
      } catch {
        localStorage.removeItem('janimony_agent');
      }
    }
    setLoading(false); // FIX: done reading
  }, []);

  const logout = () => {
    localStorage.removeItem('janimony_agent');
    setAgent(null);
  };

  return { agent, loading, logout };
};